import { useState, type CSSProperties } from 'react';
import { PlayerAvatar } from './PlayerAvatar';
import { playerRating } from '../competition';
import { teamImageByName } from '../data';
import type { Player } from '../types';
import { ElementIcon } from './ElementIcon';
import { TeamBadge } from './TeamBadge';

/** Rating from which a card gets the foil treatment (real stat, no invented rarity). */
export const ACE_RATING = 70;

export function PlayerCard({ player, onClick, selected = false, index = 0 }: { player: Player; onClick: () => void; selected?: boolean; index?: number }) {
  const [imageFailed, setImageFailed] = useState(false);
  const teamName = player.metadata?.team ?? 'Sin equipo';
  const teamImage = teamImageByName.get(teamName.toLocaleLowerCase());
  const rating = playerRating(player);
  const isAce = rating >= ACE_RATING;
  return <button
    className={`pcard player-element--${player.element.toLowerCase()} ${isAce ? 'is-ace' : ''} ${selected ? 'selected' : ''}`}
    style={{ '--i': index % 20 } as CSSProperties}
    onClick={onClick}
    title={isAce ? `${player.name} · jugador destacado (media ${ACE_RATING}+)` : player.name}
  >
    <span className="pcard-bg" aria-hidden="true" />
    <span className="pcard-art">
      {player.image_url && !imageFailed
        ? <img src={player.image_url} alt={player.name} loading="lazy" referrerPolicy="no-referrer" onError={() => setImageFailed(true)} />
        : <PlayerAvatar player={player} size="lg" />}
    </span>
    <span className="pcard-rating"><b>{rating}</b><small>{player.position}</small></span>
    <span className="pcard-element"><ElementIcon element={player.element} size="md" /></span>
    <span className="pcard-plate">
      <b className="pcard-name">{player.name}</b>
      <small className="pcard-sub">{player.metadata?.nickname ?? player.metadata?.game ?? 'Jugador'}</small>
      <span className="pcard-team"><TeamBadge name={teamName} imageUrl={teamImage} size="sm" /><span>{teamName}</span></span>
    </span>
  </button>;
}
